module.exports = __webpack_public_path__ + "img/signature-sample2_en.55c18829.png";